import React from 'react';
import InfoHeader from '../../../sharedModules/layout/InfoHeader';

import { BackflowJobItem } from '../../model';

const infoLabels = {
  schedule_dates: 'Dates',
  order_no: 'Order No',
  company_name: 'Company',
  asset_no: 'Asset No',
  display_emp_id: 'Testing Tech',
};

interface BackflowJobItemInfoHeaderProps {
  backflowJobItem: BackflowJobItem;
}

const BackflowJobItemInfoHeader: React.FC<BackflowJobItemInfoHeaderProps> = (props) => {
  const { backflowJobItem } = props;

  return <InfoHeader record={backflowJobItem} infoLabels={infoLabels} />;
};

export default BackflowJobItemInfoHeader;
